import {
    COMPONENT_SEARCH,
    CLEAR_COMPONENT_SEARCH,
    SET_INPUT_SEARCH,
    SET_SELECTED_TAB,
    GET_PARKS,
    SET_CURRENT_PARK,
    SET_CURRENT_COMPONENT,
} from "./componentsParkConstants";
import { setValue } from "../../lib/immutable_wrapper";

const componentsParkInitialState = {
    inputSearch: "",
    selectedTab: 0,
    parks: [],
    currentPark: null,
    currentComponent: null,
};

export function componentsPark(state = componentsParkInitialState, action) {
    switch (action.type) {
        case COMPONENT_SEARCH:
        case CLEAR_COMPONENT_SEARCH:
        case SET_CURRENT_COMPONENT:
            return setValue(state, ["currentComponent"], action.currentComponent);
        case SET_INPUT_SEARCH:
            return setValue(state, ["inputSearch"], action.inputSearch);
        case SET_SELECTED_TAB:
            return setValue(state, ["selectedTab"], action.selectedTab);
        case GET_PARKS:
            return setValue(state, ["parks"], action.parks);
        case SET_CURRENT_PARK:
            return setValue(state, ["currentPark"], action.currentPark);
        default:
            return state;
    }
}
